import { Map } from 'immutable'
import { browserHistory } from 'react-router'

import accountService from '../services/account'

import * as authenticationActions from './authentication'
import {
  SENT_INVITATIONS_SUCCESS,
  DELETE_WOPI,
  GENERATING_NO_EMAIL_INVITATIONS_SUCCESS
} from './questionnaire-admin'
import {
  CREATE_SUCCESS as CREATE_WOPI_360,
  DELETE_TARGET_SUCCESS as DELETE_WOPI_360
} from './wopi360-targets-admin'
import { UPDATE_ORGANISATION_SUCCESS, DELETE_ORGANISATION_SUCCESS } from './super-admin'
import { LOGOUT } from './authentication'

const FETCH_CURRENT_ACCOUNT = 'authentication/FETCH_CURRENT_ACCOUNT'
const FETCH_NEW_ACCOUNT = 'activation/FETCH_NEW_ACCOUNT'
const SWITCH_LANGUAGE = 'language/SWITCH_LANGUAGE'
const IS_PASSWORD_RESET_TOKEN_VALID = 'language/IS_PASSWORD_RESET_TOKEN_VALID'
const IS_PASSWORD_RESET_EMAIL_EXISTING = 'language/IS_PASSWORD_RESET_EMAIL_EXISTING'
const SET_CURRENT_ORGANISATION = 'authentication/SET_CURRENT_ORGANISATION'

const defaultState = Map({
  currentAccount: null,
  currentOrganisation: null,
  originalOrganisation: null,
  currentLanguage: null,
  accountWaitingForVerification: null,
  isAccountVerificationTokenValid: null,
  isPasswordResetTokenValid: null,
  isPasswordResetEmailExisting: null
})

export default function(state = defaultState, action = undefined) {
  switch (action.type) {
    case FETCH_CURRENT_ACCOUNT:
      return state
        .update('currentAccount', account => action.payload.account)
        .update('currentOrganisation', organisation => {
          // TODO: Supports only single organisation for now.
          return action.payload.organisations[0]
        })
        .update('originalOrganisation', organisation => {
          // This is used in some places to figure out the organisation related
          // to account, even if current one is changed.
          return action.payload.organisations[0]
        })
        .update('currentLanguage', language => action.payload.account.currentLanguage)

    case SET_CURRENT_ORGANISATION:
      return state.update('currentOrganisation', organisation => action.payload)

    case SWITCH_LANGUAGE:
      return state.update('currentLanguage', language => action.payload)

    case FETCH_NEW_ACCOUNT:
      return state
        .update('accountWaitingForVerification', account => action.payload.account)
        .update(
          'isAccountVerificationTokenValid',
          isValid => action.payload.isAccountVerificationTokenValid
        )

    case IS_PASSWORD_RESET_TOKEN_VALID:
      return state.update('isPasswordResetTokenValid', isValid => action.payload)

    case IS_PASSWORD_RESET_EMAIL_EXISTING:
      return state.update('isPasswordResetEmailExisting', isValid => action.payload)

    case GENERATING_NO_EMAIL_INVITATIONS_SUCCESS:
    case SENT_INVITATIONS_SUCCESS:
    case DELETE_WOPI:
      return state.update('currentOrganisation', currentOrganisation => {
        if (action.payload.response.creditsWopi !== undefined) {
          currentOrganisation.organisation.creditsWopi = action.payload.response.creditsWopi
        }

        return currentOrganisation
      })

    case CREATE_WOPI_360:
    case DELETE_WOPI_360:
      return state.update('currentOrganisation', currentOrganisation => {
        if (action.payload.creditsWopi360 !== undefined) {
          currentOrganisation.organisation.creditsWopi360 = action.payload.creditsWopi360
        }

        return currentOrganisation
      })

    case UPDATE_ORGANISATION_SUCCESS:
      return state.update('currentOrganisation', currentOrganisation => {
        const { id, creditsWopi, creditsWopi360 } = action.payload

        if (id === currentOrganisation.organisation.id) {
          currentOrganisation.organisation.creditsWopi = creditsWopi
          currentOrganisation.organisation.creditsWopi360 = creditsWopi360
        }

        return currentOrganisation
      })

    case DELETE_ORGANISATION_SUCCESS:
      return state.update('currentOrganisation', currentOrganisation => {
        const { id } = action.payload

        if (id === currentOrganisation.organisation.id) {
          return state.get('originalOrganisation')
        }

        return currentOrganisation
      })

    case LOGOUT:
      return defaultState

    default:
      return state
  }
}

export function getCurrentAccount() {
  return function d(dispatch) {
    return accountService
      .getCurrentAccount()
      .then(response => dispatch({ type: FETCH_CURRENT_ACCOUNT, payload: response.data }))
      .catch(e => browserHistory.push('/login'))
  }
}

export function tryGetCurrentAccount() {
  return dispatch => {
    return accountService
      .getCurrentAccount()
      .then(response => dispatch({ type: FETCH_CURRENT_ACCOUNT, payload: response.data }))
      .catch(e => {
        if (e.response && e.response.status === 401) {
          // no op
        } else {
          throw e
        }
      })
  }
}

export function changeLanguage(language) {
  return function d(dispatch) {
    dispatch({ type: SWITCH_LANGUAGE, payload: language })
  }
}

export function update(language, signature) {
  return function d(dispatch) {
    return accountService.save(language, signature).then(response => getCurrentAccount()(dispatch))
  }
}

export function getByVerificationToken(uuid) {
  return function d(dispatch) {
    dispatch({
      type: FETCH_NEW_ACCOUNT,
      payload: { account: null, isAccountVerificationTokenValid: null }
    })

    return accountService.getByVerificationToken(uuid).then(response => {
      dispatch({
        type: FETCH_NEW_ACCOUNT,
        payload: {
          account: response.data.account,
          isAccountVerificationTokenValid: response.data.account !== null
        }
      })

      if (response.data.account !== null) {
        changeLanguage(response.data.account.currentLanguage)(dispatch)
      }
    })
  }
}

export function verify(uuid, email, password) {
  return function d(dispatch) {
    return accountService
      .verify(uuid, password)
      .then(response => authenticationActions.login(email, password)(dispatch))
      .catch(response => console.log(response)) // TODO: Sane error.
  }
}

export function sendPasswordResetMail(username) {
  return function d(dispatch) {
    dispatch({ type: IS_PASSWORD_RESET_EMAIL_EXISTING, payload: null })

    return accountService
      .sendResetPasswordMail(username.toLowerCase())
      .then(response => browserHistory.push('/forgot-password/sent'))
      .catch(response => dispatch({ type: IS_PASSWORD_RESET_EMAIL_EXISTING, payload: false }))
  }
}

export function resetPassword(token, password) {
  return function d(dispatch) {
    return accountService
      .resetPassword(token, password)
      .then(response => browserHistory.push('/login'))
  }
}

export function isPasswordResetTokenValid(uuid) {
  return function d(dispatch) {
    dispatch({ type: IS_PASSWORD_RESET_TOKEN_VALID, payload: null })

    return accountService
      .isPasswordResetTokenValid(uuid)
      .then(response => dispatch({ type: IS_PASSWORD_RESET_TOKEN_VALID, payload: true }))
      .catch(response => dispatch({ type: IS_PASSWORD_RESET_TOKEN_VALID, payload: false }))
  }
}

export function setCurrentOrganisation(organisation) {
  return function d(dispatch) {
    dispatch({ type: SET_CURRENT_ORGANISATION, payload: organisation })
  }
}



// WEBPACK FOOTER //
// ./src/ducks/account.js